export const DEFAULT_PAGE_SIZE = 10;
export const BRANCH_KEYS = new Set(['and', 'or', 'not']);
